export default __webpack_public_path__ + "static/media/dropdown_arrow_down.2523ef10.svg";